import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f262c2ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "item__txt" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_6 = { class: "item__txt" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_9 = { class: "item__txt" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_12 = { class: "item__img" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "任务提交原图：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stick" }, null, -1))
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { style: {"margin-bottom":"15px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "地图信息：", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "map__container",
  id: "diff-map-container"
}, null, -1))

import { onMounted, ref, onUnmounted } from 'vue';
import {
  BaseToolTip,
  BaseButton,
  BaseAutocomplete,
  BaseImage
} from 'xrk-components';
import { locationMapComparison } from '../data-source/apis';
import { ProjectType } from '../types';
import jsonp from 'jsonp';
import { QQ_MAP_KEY } from '@/config';

export default /*#__PURE__*/_defineComponent({
  __name: 'deef-map',
  props: {
    taskRecordId: {},
    projectId: {},
    projectType: {},
    dataState: {},
    done: {}
  },
  setup(__props: any) {

const props = __props;
const qq = Reflect.get(window, 'qq');
const address = ref('');
const detail = ref({
  customerName: '',
  visitAddress: '',
  ssq: '',
  addressWatermarkPicUrl: '',
  visitLongitude: '',
  visitLatitude: ''
});

const map = ref(null);
const marker = ref(null);

const mapSuggestion = keyword => {
  return new Promise(resolve => {
    try {
      jsonp(
        `//apis.map.qq.com/ws/place/v1/suggestion?keyword=${keyword}&output=jsonp&page_size=20&page_index=1&key=${QQ_MAP_KEY}`,
        null,
        (err, data) => {
          if (err) {
            console.log(err);
          } else {
            resolve(data.data);
          }
        }
      );
    } catch (error) {
      console.log(error);
      resolve([]);
    }
  });
};

const handleSelect = item => {
  //经度
  detail.value.visitLongitude = item.address.lng;
  //纬度
  detail.value.visitLatitude = item.address.lat;
};
const querySearch = (queryString, cb) => {
  if (!address.value) {
    cb([]);
    return;
  }
  mapSuggestion(address.value).then((res: any[]) => {
    let resList = res.map(item => {
      return {
        value: item.title + `(${item.address})`,
        address: item.location
      };
    });
    cb(resList);
  });
};
const initMap = () => {
  const lat = detail.value.visitLatitude;
  const lng = detail.value.visitLongitude;
  const options = {
    zoom: 17,
    pitchable: false,
    rotatable: false,
    disableDefaultUI: true,
    mapTypeId: qq.maps.MapTypeId.ROADMAP
  };
  options['center'] = new qq.maps.LatLng(lat, lng);
  map.value = new qq.maps.Map(
    document.getElementById('diff-map-container'),
    options
  );
  marker.value = new qq.maps.Marker({
    animation: null,
    position: new qq.maps.LatLng(lat, lng),
    map: map.value
  });
};
const handleEsc = event => {
  if (event.key === 'Escape') {
    props.done();
  }
};
onMounted(async () => {
  const { data } = await locationMapComparison({
    sceneType: props.projectType,
    projectId: props.projectId,
    taskRecordId: props.taskRecordId,
    dataState: props.dataState
  });
  Object.assign(detail.value, data);
  initMap();
  window.addEventListener('keydown', handleEsc);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (detail.value.customerName)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "目标名称："))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseToolTip), {
          "popper-class": "main__tooltip",
          effect: "dark",
          content: detail.value.customerName,
          placement: "top-start"
        }, {
          default: _withCtx(() => [
            (detail.value.customerName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(detail.value.customerName), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (detail.value.customerName)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_7, "目标地址："))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseToolTip), {
          "popper-class": "main__tooltip",
          effect: "dark",
          content: detail.value.visitAddress,
          placement: "top-start"
        }, {
          default: _withCtx(() => [
            (detail.value.customerName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(detail.value.visitAddress), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (detail.value.customerName)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_10, "省市区："))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseToolTip), {
          "popper-class": "main__tooltip",
          effect: "dark",
          content: detail.value.ssq,
          placement: "top-start"
        }, {
          default: _withCtx(() => [
            (detail.value.customerName)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(detail.value.ssq), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, [
          _createVNode(_unref(BaseImage), {
            previewTeleported: true,
            fit: "contain",
            src: detail.value.addressWatermarkPicUrl,
            "preview-src-list": [detail.value.addressWatermarkPicUrl]
          }, null, 8, ["src", "preview-src-list"])
        ])
      ])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_unref(BaseAutocomplete), {
          style: {"width":"80%"},
          modelValue: address.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
          "fetch-suggestions": querySearch,
          ref: "addrselect",
          onSelect: handleSelect
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(BaseButton), {
          onClick: initMap,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("搜索")
          ]),
          _: 1
        })
      ]),
      _hoisted_17,
      _hoisted_18
    ])
  ]))
}
}

})